import FormConfig from "../formConfig.js";
import { fun_PostAction } from "@/api/index";
import { Loading } from "element-ui";
import CaLock from "@/components/common/calock";
// 引入历史核验页面
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
// 引入项目信息选择
import EvaluationRecordProjectInfo from "../../components/evaluationRecordProjectInfoChoose/index.vue";
// 引入中标候选人信息选择
import EvaluationRecordCandidate from "../../components/evaluationRecordCandidateChoose/index.vue";
export default {
  data() {
    return {
      // 用于判断显示状态
      formState: null,
      // 全局加载
      fullLoading: false,
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        prjName: null, // 项目名称
        tenderReference: null, // 招标编号
        evaluationStartTime: null, // 定标时间
        basicInfoName: null, // 实际中标人名称
        basicInfoId: null, // 实际中标人编号
        supplement: null, // 是否需要递补
        reason: null, // 定标理由
        remarks: null, // 备注
        publicityNumber: null, // 中标公示编号
        state: null, // 状态
        stateName: null, // 状态名称
        tenderOpinion: null, // 招标人意见
        lockNo: null, // 锁编号
        digitalSignature: null // 数字签名
      },
      // 表单错误
      errRules: {
        id: null, // 主键
        prjName: null, // 项目名称
        tenderReference: null, // 招标编号
        evaluationStartTime: null, // 定标时间
        basicInfoName: null, // 实际中标人名称
        basicInfoId: null, // 实际中标人编号
        supplement: null, // 是否需要递补
        reason: null, // 定标理由
        remarks: null, // 备注
        publicityNumber: null, // 中标公示编号
        state: null, // 状态
        stateName: null, // 状态名称
        tenderOpinion: null, // 招标人意见
        lockNo: null, // 锁编号
        digitalSignature: null // 数字签名
      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      controllerFlg: this.$route.query.type, // 操作标志
      id: this.$route.query.id, // 主键
      isTenderSignature: this.$route.query.isTenderSignature, // 是否甲方确认
      /************************甲方确认使用**************************/
      // 甲方确认表单
      tenderSignedForm: {
        table: null, // 表名
        key: null, // 字段
        recordNumber: null, // 数据编号
        tenderOpinion: null, // 招标人意见
        tenderSignedId: null, // 招标人签章确认编号
        tenderSignedState: null, // 招标人签章状态
        isDeregulation: null, // 添加标记
        esRegulators: null, // 招标人盖章确认的招标监管部门
        esProcessType: null, // 招标人盖章确认的招标监管流程
        esInvitationId: null, // 招标人盖章确认权限编号
        tenderStampData: null, // 招标人盖章的数字签名
        title: null // 判断当前时提交还是退还至招标代理
      },
      /*****************************定标委员会成员信息****************************/
      committeeLoading: false, // 列表loading状态
      // 表头按钮组
      committeeBtnList: [
        {
          name: "添加",
          type: "success",
          icon: "circle-plus-outline"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 查询表单字段
      committeeForm: {},
      // 表格基础数据
      committeeTableColumns: [
        {
          label: "参与人姓名",
          prop: "name"
        },
        {
          label: "工作单位",
          prop: "corpName"
        }
      ],
      committeeRules: {
        name: [
          {
            required: true,
            message: "请输入参与人姓名",
            trigger: "blur"
          }
        ],
        corpName: [
          {
            required: true,
            message: "请输入工作单位",
            trigger: "blur"
          }
        ]
      },
      // 表单
      committeeFormObj: {
        // 表格数据
        committeeTableData: []
      },
      committeeMultipleSelection: [] // 勾选数组
    };
  },
  // 注册组件
  components: {
    CaLock, // CA锁
    EvaluationRecordProjectInfo, // 项目信息选择
    EvaluationRecordCandidate, // 中标候选人选择
    AuditHistoryRecord // 核验记录
  },
  // 模板编译完成
  mounted() {
    // 打开loading
    this.loading = true;
    // 获取详情信息
    this.fun_Details();
    // 如果是详情
    if (this.controllerFlg == "details") {
      // 遍历表单
      this.formConfigList.map(e => {
        // 遍历
        e.formConfigList.map(form => {
          // 不可编辑
          form.disabled = true;
        });
      });
    }
    // 默认全部展开
    this.$refs.collapseForm.activeNames = this.formConfigList.map(item => {
      return item.name;
    });
  },
  // 自定义方法
  methods: {
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 请求，获取结果集
      fun_PostAction("/evaluationRecord/detail", {
        controllerFlg: this.controllerFlg, // 操作标志
        id: this.id, // 主键
        isTenderSignature: this.isTenderSignature // 是否甲方确认
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data.model;
          // 获取状态
          this.formState = data.model.state;
          // 设置定标委员会成员信息一览
          this.fun_CommitteeList();
          // 设置甲方确认
          this.fun_GetTenderSignature(data);
          // 关闭loading
          this.loading = false;
        }
      });
    },
    /**
     * 项目选择
     */
    fun_GetProjectInfo(e) {
      // 如果是选择
      if (e == "open") {
        // 打开弹窗
        this.$refs.evaluationRecordProjectInfo.dialogVisible = true;
        // 请求接口
        this.$refs.evaluationRecordProjectInfo.fun_GetOpen();
      }
      // 如果是清空招标公告项目
      else {
        // 清项目名称
        this.form.prjName = "";
        // 清招标编号
        this.form.tenderReference = "";
        // 清中标公告编号
        this.form.publicityNumber = "";
      }
    },
    /**
     * 设置项目信息
     * @param e
     */
    fun_SetProjectInfo(e) {
      // 设置项目名称
      this.form.prjName = e.prjName;
      // 设置招标编号
      this.form.tenderReference = e.tenderReference;
      // 设置中标公告编号
      this.form.publicityNumber = e.id;
    },
    /**
     * 中标候选人弹框
     */
    fun_GetBasicInfo() {
      // 如果中标公示编号为空
      if (
        this.form.publicityNumber == "" ||
        this.form.publicityNumber == null
      ) {
        // 请求失败，弹出失败msg的消息提示
        this.$message.error("请优先选择招标项目！");
        return false;
      }
      // 打开弹窗
      this.$refs.evaluationRecordCandidate.dialogVisible = true;
      // 请求接口
      this.$refs.evaluationRecordCandidate.fun_GetOpen();
    },
    /**
     * 设置中标候选人
     */
    fun_SetBasicInfo(e) {
      // 设置中标候选人编号
      this.form.basicInfoId = e.basicInfoId;
      // 设置中标候选人名称
      this.form.basicInfoName = e.basicInfoName;
    },
    /**
     * 定标委员会成员信息一览
     */
    fun_CommitteeList() {
      // 主键不为空时
      if (this.form.id != "" && this.form.id != null) {
        // 如果是详情
        if (this.controllerFlg == "details") {
          // 清空表头按钮
          this.committeeBtnList = [];
        }
        // 请求，获取结果集
        fun_PostAction("/evaluationRecord/committeeList", {
          evaluationId: this.form.id
        }).then(res => {
          // 解构res.data
          const { result, data } = res.data;
          // 判断请求是否成功
          if (result) {
            // 回显table
            this.committeeFormObj.committeeTableData = data;
          }
        });
      }
    },
    /**
     * 定标委员会成员信息勾选事件
     * @params e 选中的数据
     */
    fun_CommitteeHandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.committeeMultipleSelection = e;
    },
    /**
     * 定标委员会成员信息表头按钮事件
     */
    fun_CommitteeClick(e) {
      switch (e) {
        case "添加":
          this.fun_CommitteeAdd();
          break;
        case "删除":
          this.fun_CommitteeDel();
          break;
        default:
      }
    },
    /**
     * 列表添加class
     */
    addClass(row, column, rowIndex, columnIndex) {
      // 判断是序号
      if (row.column.type === "index") {
        return "index";
      }
    },
    /**
     * 添加时执行的方法
     * @author shuhua
     */
    tableRowClassName(row, rowIndex) {
      // 给每一行新增一个下标
      row.row.index = row.rowIndex;
    },
    /**
     * 定标委员会成员信息表表新增
     */
    fun_CommitteeAdd() {
      // 调用添加方法
      let newValue = {
        name: null,
        corpName: null
      };
      //添加新的行数
      this.committeeFormObj.committeeTableData.push(newValue);
    },
    /**
     * 资格预审评审小组成员名单表删除
     */
    fun_CommitteeDel() {
      // 判断是否勾选
      if (this.committeeMultipleSelection.length <= 0) {
        // 提示信息
        this.$alert("最少选择一条数据！", "warning");
        return;
      }
      // 弹出询问confirm
      this.$confirm("是否确定删除选中数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 遍历
        this.committeeMultipleSelection.map((value, index) => {
          // 遍历
          this.committeeFormObj.committeeTableData.map((v, i) => {
            // 匹配已选中的
            if (value.index === v.index) {
              // 删除勾选的数据
              this.committeeFormObj.committeeTableData.splice(i, 1);
            }
          });
        });
        // 清除选中数据
        this.$refs.multipleTable.clearSelection();
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 保存修改
     * @param e
     */
    fun_InsUpd(e) {
      // 设置状态
      this.form.state = e;
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 如果是保存
          if (e == "bc") {
            // 提交的方法
            this.fun_Submit();
          }
          // 如果是提交
          else {
            // 如果未录入定标委员会成员信息
            if (this.committeeFormObj.committeeTableData.length == 0) {
              // 请求失败，弹出失败msg的消息提示
              this.$message.error("请录入定标委员会成员信息！");
              return false;
            }
            // 开启弹窗
            this.$refs.caLock.dialogCalock = true;
            // 签名数据, 交易人名称和日期
            this.$refs.caLock.data =
              this.form.prjName +
              this.form.tenderReference +
              this.form.basicInfoId;
            // 状态
            this.$refs.caLock.state = e;
          }
        } else {
          return false;
        }
      });
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature) {
      // 遍历错误消息
      for (let i in this.errRules) {
        // 设置为空
        this.errRules[i] = null;
      }
      // ca弹窗关闭
      this.$refs.caLock.dialogCalock = false;
      // 赋值锁编号
      this.form.lockNo = lockNo;
      // 赋值数字签名
      this.form.digitalSignature = digitalSignature;
      // 不为空
      if (this.title != "" && this.title != null) {
        // 招标人提交
        this.fun_TenderStampSubmit();
      } else {
        // 确定的方法
        this.fun_Submit();
      }
    },
    /**
     * 确定的方法
     */
    fun_Submit() {
      // 全局加载框
      this.fullLoading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
      try {
        // 请求
        fun_PostAction("/evaluationRecord/saveOrUpdate", {
          ...this.form, // form表单数据
          controllerFlg: this.controllerFlg, // 操作标志
          committeeList: JSON.stringify(
            this.committeeFormObj.committeeTableData
          ) // 定标委员会成员信息
        }).then(res => {
          // 加载框取消
          this.fullLoading.close();
          // 解构res.data
          const { result, data, msg } = res.data;
          // 解析后台返回的结果集，判断是否成功
          if (result) {
            // 操作成功
            this.$message.success(msg);
            // 返回一览
            this.fun_Back();
          } else {
            // 如果页面验证失败
            if (data != null && data != "") {
              // 返回错误消息
              this.errRules = data;
              // 请求失败，弹出失败msg的消息提示
              this.$message.error("您输入的数据存在错误！");
            } else {
              // 请求失败，弹出失败msg的消息提示
              this.$message.error(msg);
            }
          }
          // 关闭loading
          this.loading = false;
        });
      } catch (e) {
        // 请求失败，弹出失败msg的消息提示
        this.$message.error("操作失败！" + e);
        // 加载框取消
        this.fullLoading.close();
      }
    },
    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },
    /**
     * 甲方确认
     */
    fun_GetTenderSignature(data) {
      this.form.tenderOpinion = data.tenderOpinion; // 招标人意见
      this.tenderSignedForm.table = data.model.tableName; // 表名
      this.tenderSignedForm.key = data.model.keyState; // 字段
      this.tenderSignedForm.recordNumber = data.model.id; // 数据编号
      this.tenderSignedForm.tenderOpinion = data.tenderOpinion; // 招标人意见
      this.tenderSignedForm.tenderSignedId = data.tenderSignedId; // 招标人签章确认编号
      this.tenderSignedForm.tenderSignedState = data.tenderSignedState; // 招标人签章状态
      this.tenderSignedForm.isDeregulation = data.isDeregulation; // 添加标记
      this.tenderSignedForm.esRegulators = data.esRegulators; // 招标人盖章确认的招标监管部门
      this.tenderSignedForm.esProcessType = data.esProcessType; // 招标人盖章确认的招标监管流程
      this.tenderSignedForm.esInvitationId = data.esInvitationId; // 招标人盖章确认权限编号
      this.tenderSignedForm.tenderStampData = data.tenderStampData; // 招标人盖章的数字签名
      //  招标人签章状态为提交，且状态不等于1
      if (data.tenderSignedState == "tj" && data.isDeregulation != "1") {
        // 遍历
        this.formConfigList.map((value, index) => {
          // 招标人意见
          if (value.title === "其他") {
            // 遍历
            this.formConfigList[index].formConfigList.map(j => {
              // 如果是招标人意见
              if (j.value == "tenderOpinion") {
                // 可编辑
                j.disabled = false;
              }
            });
          }
        });
      } else {
        // 遍历
        this.formConfigList.map((value, index) => {
          // 招标人意见
          if (value.title === "其他") {
            // 遍历
            this.formConfigList[index].formConfigList.map(j => {
              // 如果是招标人意见
              if (j.value == "tenderOpinion") {
                // 不可编辑
                j.disabled = true;
              }
            });
          }
        });
      }
    },
    /**
     * 甲方确认提交与退还
     */
    fun_TenderStamp(e) {
      // 如果招标人意见不为空
      if (this.form.tenderOpinion != "" && this.form.tenderOpinion != null) {
        // 设置招标人意见
        this.tenderSignedForm.tenderOpinion = this.form.tenderOpinion;
      }
      // 开启弹窗
      this.$refs.caLock.dialogCalock = true;
      // 签名数据, 交易人名称和日期
      this.$refs.caLock.data =
        this.form.prjName + this.form.tenderReference + this.form.basicInfoId;
      // 状态
      this.$refs.caLock.state = e;
      this.$refs.caLock.tenderSigned = e;
      this.$refs.caLock.tenderSignedForm = this.tenderSignedForm;
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    }
  }
};
